__turbopack_context__.v({
  "flota1": "flota-module__XwJX6a__flota1",
  "flota2": "flota-module__XwJX6a__flota2",
  "flota3": "flota-module__XwJX6a__flota3",
  "flotaCorta": "flota-module__XwJX6a__flotaCorta",
  "flotaLarga": "flota-module__XwJX6a__flotaLarga",
  "flotaMedia": "flota-module__XwJX6a__flotaMedia",
  "pausada": "flota-module__XwJX6a__pausada",
  "quieto": "flota-module__XwJX6a__quieto",
});
